import firebase from 'firebase/app'

const config = {"apiKey":"AIzaSyDIT7IWYAmsxsFZXdz07udcjspQ-N2EEUM","authDomain":"tb-co-th-263110.firebaseapp.com","databaseURL":"https:\u002F\u002Ftb-co-th-263110.firebaseio.com","projectId":"tb-co-th-263110","storageBucket":"tb-co-th-263110.appspot.com","messagingSenderId":"314789490062","appId":"1:314789490062:web:7fe942f058a407b65c88df","measurementId":"G-JF62M826QS"}

export default async ({ res }, inject) => {
  if (!firebase.apps.length) {
    firebase.initializeApp(config)
  }
  const session = firebase.apps[0]

  /** --------------------------------------------------------------------------------------------- **/
  /** ------------------------------------ FIREBASE REALTIME DB ----------------------------------- **/
  /** --------------------------------------------------------------------------------------------- **/

  await import('firebase/database')

  const fireDb = session.database()
  const fireDbObj = firebase.database
  inject('fireDb', fireDb)
  inject('fireDbObj', fireDbObj)

  /** --------------------------------------------------------------------------------------------- **/
  /** ------------------------------------- FIREBASE FIRESTORE ------------------------------------ **/
  /** --------------------------------------------------------------------------------------------- **/

  await import('firebase/firestore')

  const fireStore = session.firestore()
  const fireStoreObj = firebase.firestore
  inject('fireStore', fireStore)
  inject('fireStoreObj', fireStoreObj)

  /** --------------------------------------------------------------------------------------------- **/
  /** ------------------------------------ FIREBASE FUNCTIONS ------------------------------------- **/
  /** --------------------------------------------------------------------------------------------- **/

  await import('firebase/functions')

  const fireFunc = session.functions()
  const fireFuncObj = firebase.functions

  inject('fireFunc', fireFunc)
  inject('fireFuncObj', fireFuncObj)
}
